import(/* webpackMode: "eager", webpackExports: ["LegalPage"] */ "/Users/rohangupta/creatr/platform/creatr-platform/apps/frontend/src/components/legal/legal-page.tsx");
